export const sortTemplates = <T extends { visibility: string; subject: string }>(
    templates: T[],
): T[] =>
    templates.slice().sort((a, b) => {
        const visibilityComparison = a.visibility.localeCompare(b.visibility);
        if (visibilityComparison !== 0) {
            return visibilityComparison;
        }
        return a.subject.localeCompare(b.subject);
    });
